"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var specialCoverages_1 = require("../constants/specialCoverages");
var QuotationCoverage_1 = require("../models/QuotationCoverage");
var emptyCoverage = QuotationCoverage_1.makeEmptyQuotationCoverage();
var mockQuotationCoverageList = [
    __assign(__assign({}, emptyCoverage), { coverageId: '001', insuredValue: 5000.0, deductible: 0.0 }),
    __assign(__assign({}, emptyCoverage), { coverageId: '002', insuredValue: 10000.0, deductible: 0.0 }),
    __assign(__assign({}, emptyCoverage), { coverageId: '003', insuredValue: 1000.0, deductible: 0.0 }),
    __assign(__assign({}, emptyCoverage), { coverageId: '004', insuredValue: 0.0, deductible: 378.0 }),
    __assign(__assign({}, emptyCoverage), { coverageId: '005', insuredValue: 0.0, deductible: 1156.0 }),
    __assign(__assign({}, emptyCoverage), { coverageId: specialCoverages_1.ASSAMOVIL_PREMIUM }),
    __assign(__assign({}, emptyCoverage), { coverageId: specialCoverages_1.LUXURY_TRANSPORTATION_SERVICE, price: 100 }),
];
exports.default = mockQuotationCoverageList;
//# sourceMappingURL=mockQuotationCoverageList.js.map